export default __webpack_public_path__ + "assets/images/53dc2852af635961c095984417446642.jpg";